import { Ingredient } from '../apiTypes';
import { t } from '../constants/translations';
import { Lang } from '../contexts/locale.context';

const getQntLabel = (qnt: number | undefined, ing: Ingredient | undefined, lang: Lang, disablePacking?: boolean) => {
  if (!ing) {
    return '';
  }

  if (!qnt) {
    return `0${t[ing.unit][lang]}`;
  }

  if (disablePacking) {
    return `${qnt}${t[ing.unit][lang]}`;
  }

  if (!ing.qpp) {
    if (ing.unit === 'pc' || (qnt < 1000 && qnt > -1000)) {
      return `${qnt}${t[ing.unit][lang]}`;
    }

    if (qnt < 0) {
      return `${Math.ceil(qnt / 1000)}${ing.unit === 'g' ? t.kg[lang] : t.l[lang]} ${
        qnt % 1000 ? `${-qnt % 1000}${t[ing.unit][lang]}` : ''
      }`;
    }

    return `${Math.floor(qnt / 1000)}${ing.unit === 'g' ? t.kg[lang] : t.l[lang]} ${
      qnt % 1000 ? `${qnt % 1000}${t[ing.unit][lang]}` : ''
    }`;
  }

  if (ing.unit === 'pc' || (qnt < ing.qpp && qnt > -ing.qpp)) {
    return `${qnt}${t[ing.unit][lang]}`;
  }

  if (qnt < 0) {
    return `${Math.ceil(qnt / ing.qpp)}${t.pac[lang]} ${
      qnt % ing.qpp ? `${t.and[lang]} ${-qnt % ing.qpp}${t[ing.unit][lang]}` : ''
    }`;
  }

  return `${Math.floor(qnt / ing.qpp)}${t.pac[lang]} ${
    qnt % ing.qpp ? `${t.and[lang]} ${qnt % ing.qpp}${t[ing.unit][lang]}` : ''
  }`;
};

export default getQntLabel;
